import * as React from "react";
import {
    Card,
    CardContent,
    Grid,
    CardActions,
    Typography,
    Button,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
} from '@material-ui/core';
import clsx from 'clsx';
import ProgressSaveButton from "../../../../components/_Layout/Buttons/ProgressSaveButton";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import EnrollmentStatusAutoComplete from "../../../../components/AutoComplete/EnrollmentStatusAutoComplete";
import ProgramVersionAutoComplete from "../../../../components/AutoComplete/ProgramVersionAutoComplete";
import StudentGroupsAutoComplete from "../../../../components/AutoComplete/StudentGroupsAutoComplete";
import CourseAutoComplete from "../../../../components/AutoComplete/CourseAutoComplete";
import GradingComponentsAutoComplete from "../../../../components/AutoComplete/GradingComponentsAutoComplete";
import { ISearchFilters } from "../../../../interfaces/student/academics/PostGradesByClassFilter";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from "@material-ui/pickers";
import { useForm } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import TermCalenderAutoComplete from "../../../../components/AutoComplete/TermCalenderAutoComplete";
import ClassAutoComplete from "../../../../components/AutoComplete/ClassAutoComplete";
import CreditProgramVersionAutoComplete from "../../../../components/AutoComplete/CreditProgramVersionAutoComplete";
import GradeBookComponentsAutoComplete from "../../../../components/AutoComplete/GradeBookComponentsAutoComplete";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
            height: "100%",
            minHeight: "100%",
            paddingTop: theme.spacing(3),
            overflowX: "hidden",
            overflowY: "auto"
        }
        , cardTitle: {
            fontSize: 17,
            textDecoration: 'bold',
            backgroundColor: theme.palette.secondary.dark,
            padding: theme.spacing(1, 1),
        },
        filterMenu: {
            textAlign: 'right',
        },
        saveButton: {
            width: 90,
        },
        width100: {
            width: "100%",
        },
    })
);

const ITEM_HEIGHT = 90;
const ITEM_PADDING_TOP = 1;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

type filterProps = {
    handleSearch: (filters:ISearchFilters) => void;
    classId:string;
    className:string;
    isLoading:boolean;
};

const PostGradesByInstructorClassFilter = (props: filterProps) => {
    const classes = useStyles({});
    const studentId = useSelector<any, any>(
        (state: any) => state.student.studentId
    );

    const data = useForm<any>({ mode: "onBlur" });

    const campusId = useSelector((state: any) =>
        state.userstate.getSelectedCampus(state.session.user.userId)
    );

    const initialState: ISearchFilters = {
        programVersionIds: [],
        instrCreditGrdBkWgtDetailId: null,
        statusIds: [],
        campusId: campusId,
        classId: null,
        termId: null,
    };

    const [model, setModel] = React.useState<ISearchFilters>({ ...initialState });

    const handleFieldOnChange = (
        fieldId: string,
        value: any,
        mapFunction?: Function
    ) => {
        let updatedModel = model;
        let newValue = mapFunction ? mapFunction(value) : value;
        (updatedModel as any)[fieldId] = newValue;
        if (fieldId == "termId") {
            (updatedModel as any)["classId"] = null;
            (updatedModel as any)["instrCreditGrdBkWgtDetailId"] = null;
        }

        if(fieldId == 'classId'){
            (updatedModel as any)["instrCreditGrdBkWgtDetailId"] = 'FinalGrade';
        }

        props.handleSearch({...updatedModel, instrCreditGrdBkWgtDetailId: !!model.instrCreditGrdBkWgtDetailId ? model.instrCreditGrdBkWgtDetailId : 'FinalGrade'});

        setModel({ ...updatedModel });
    };

    React.useEffect(() => {
        setModel({...model, classId:props.classId, instrCreditGrdBkWgtDetailId:'FinalGrade'});
        props.handleSearch({...model, classId:props.classId, instrCreditGrdBkWgtDetailId:'FinalGrade'});
    }, [props.classId]);

    return (
        <React.Fragment>
            <Card square={true}>
                
                <CardContent>
                    <Grid container direction="row" spacing={2}>
                        
                        <Grid item md={4} sm={4} xs={12}>
                            <Typography style={{marginTop:20}}><strong>Class:</strong> {props.className}</Typography>
                        </Grid>
                        <Grid item md={4} sm={4} xs={12}>
                            <GradeBookComponentsAutoComplete
                                id="instrCreditGrdBkWgtDetailIdcredit"
                                name="instrCreditGrdBkWgtDetailId"
                                label="Grading Component"
                                key="instrCreditGrdBkWgtDetailIdcredit"
                                required={true}
                                classId={model.classId ?? ''}
                                valueFilter={
                                    model?.instrCreditGrdBkWgtDetailId
                                        ? {
                                            key: "value",
                                            values: [model?.instrCreditGrdBkWgtDetailId],
                                        }
                                        : undefined
                                }
                                filterHandle={(v: any) => {
                                    handleFieldOnChange(
                                        "instrCreditGrdBkWgtDetailId",
                                        v ? v.value : null
                                    );
                                }}

                                error={!!data.errors.instrCreditGrdBkWgtDetailId}
                                    inputRef={data.register({ required: true })}
                                    helperText={
                                      data.errors.instrCreditGrdBkWgtDetailId
                                        ? "Grading component required."
                                        : undefined
                                    }
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </React.Fragment>
    );
};

export default PostGradesByInstructorClassFilter;
